import React from "react";
import LessThenIcon from "../Assets/Icons/lessThenIcon.svg";

export default function (props) {
  return (
    <div>
      <div
        style={{ backgroundColor: props.bgcolor }}
        className="w-[22.7rem] h-full pt-5 pb-5 rounded-[12px]"
      >
        <div className="flex items-center justify-center">
          <div className="w-[90%] h-full">
            <div className="flex flex-col items-start justify-between min-h-[25vh]">
              <div>
                <h1 className="text-[1.5rem] font-[800] text-[#111928]">
                  {props.heading}
                </h1>
                <p className="text-[0.90rem] text-[#6B7280] mt-2 h-full">
                  {props.text}
                </p>
              </div>
              <div className="w-[3rem] h-[3rem] bg-white flex items-center justify-center rounded-full cursor-pointer self-end">
                <img src={LessThenIcon} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
